export enum ReportType {
    COURSE_DETAILS = 'COURSE_DETAILS',
    LP_DETAILS = 'LP_DETAILS'
}

export enum ReportStatus {
    READY = 'READY',
    IN_PROGRESS = 'IN_PROGRESS',
    ERROR = 'ERROR'
}

export type ReportEntry = {
    id: string;
    type: ReportType;
    requestedAt: string,
    status: ReportStatus
    downloadUrl: string | null
}

export type ReportsListResponse = {
    count: number;
    reports: ReportEntry[];
}